import React, { useEffect, useMemo } from "react";
import BreadcrumbComponent from "../../common/components/breadcrumb-component/breadcrumb-component";
import { useSetLoading } from "../../common/hooks/appearance";
import "./terms-of-services.scss";
import { Alert, Box, Divider, Tab, Tabs } from "@mui/material";
import { useLogin } from "../../common/hooks/useUser";
import { getTermsOfServices } from "../../api/terms-of-services";
import { AlertComponent } from "../../common/components";
import icons from "../../assets/icons/icons";

const TermsOfService: React.FC = () => {
  const [indexValue, setIndexValue] = React.useState(0);
  const [termsOfServices, setTermsOfServices] = React.useState<any>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const [alert, setAlert] = React.useState<{
    isOpen?: boolean;
    message?: any;
    type?: string;
  }>({});

  const loginData: any = useLogin();
  const isSuperTenant = loginData?.tenantDetails?.tenantType === "SuperTenant";

  const crumbMapping = [
    { label: "Terms Of Service", link: "/terms-of-service" },
  ];

  const fetchTermsOfServices = async () => {
    try {
      setIsLoading(true);
      const response = await getTermsOfServices();
      setTermsOfServices({
        defaultTermsOfServices: response?.data?.data?.defaultTermsOfServices,
        tenantTermsOfServices: response?.data?.data?.tenantTermsOfServices,
      });
      setIsLoading(false);
    } catch (err: any) {
      console.error("Error fetching terms of service:", err);
      setAlert({
        isOpen: true,
        message:
          err?.response?.data?.message ||
          err?.message ||
          err?.error ||
          "Error fetching terms of service.",
        type: "error",
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTermsOfServices();
  }, []);

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  const handleMainTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setIndexValue(newValue);
  };
  return (
    <div className="terms-of-service">
      <Box sx={{ marginBottom: "30px" }}>
        <BreadcrumbComponent breadcrumbLink={crumbMapping} />
      </Box>
      {!isSuperTenant && (
        <Box className="terms-of-service-tabs-wrapper">
          <div className="terms-of-service-tabs">
            <Box>
              <Tabs
                value={indexValue}
                onChange={handleMainTabChange}
                allowScrollButtonsMobile
                variant="scrollable"
              >
                <Tab label="Your Terms Of Service" />
                <Tab label="AFP Terms Of Service" />
              </Tabs>
            </Box>
          </div>
          <Divider />
        </Box>
      )}

      <div
        className={`terms-of-service-container ${isSuperTenant ? "super-tenant-toi" : ""}`}
      >
        {indexValue === 0 && !isSuperTenant && (
          <>
            <article
              id="post-604"
              className="post-604 page type-page status-publish hentry"
            >
              <div className="entry-content">
                {termsOfServices?.tenantTermsOfServices ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        termsOfServices?.tenantTermsOfServices
                          ?.terms_of_service_html,
                    }}
                  />
                ) : (
                  <div>
                    {!isLoading ? (
                      <Box className="alert-terms-of-service">
                        <img src={icons.TermOfServicesInfo} alt="img" />
                        <p>
                          Alert: Your company Terms of Service are not defined.
                          Add them now to inform users of your company's
                          policies.
                        </p>
                      </Box>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </div>
            </article>
          </>
        )}
        {(indexValue === 1 || isSuperTenant) &&
          termsOfServices?.defaultTermsOfServices?.terms_of_service_html && (
            <article
              id="post-604"
              className="post-604 page type-page status-publish hentry"
            >
              <div className="entry-content">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      termsOfServices?.defaultTermsOfServices
                        ?.terms_of_service_html,
                  }}
                />
              </div>
            </article>
          )}
      </div>

      {alert?.isOpen && (
        <AlertComponent
          message={alert?.message || ""}
          type={
            ["info", "success", "error", "warning"].includes(alert?.type || "")
              ? (alert?.type as "info" | "success" | "error" | "warning")
              : "info"
          }
          open={alert?.isOpen}
          onClose={() => setAlert({})}
        />
      )}
    </div>
  );
};
export default TermsOfService;
